import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const baseInput =
  "bg-[hsl(220_30%_8%)] border-border focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-0";

export const FieldText = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  type = "text",
  placeholder,
  testId,
}) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-sm text-foreground">
      {label} {required && <span className="text-primary">*</span>}
    </Label>
    <Input
      id={id}
      type={type}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className={baseInput}
      aria-invalid={!!error}
    />
    {error && (
      <p className="text-xs text-destructive" data-testid={`${testId}-error`}>
        {error}
      </p>
    )}
  </div>
);

export const FieldTextarea = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  placeholder,
  rows = 5,
  testId,
}) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-sm text-foreground">
      {label} {required && <span className="text-primary">*</span>}
    </Label>
    <Textarea
      id={id}
      rows={rows}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId}
      className={baseInput}
      aria-invalid={!!error}
    />
    {error && (
      <p className="text-xs text-destructive" data-testid={`${testId}-error`}>
        {error}
      </p>
    )}
  </div>
);

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
